import React, { useContext, useState } from "react";
import SaveUserTemplateIcon from "../../../../components/SVGComponents/SaveUserTemplateIcon";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { savePersonalTemplate } from "../../../../service/MasterService";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { Editor } from "slate";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import loaderContext from "../../../../context/loader/LoaderContext";
import toastContext from "../../../../context/toast/ToastContext";
import { t } from "i18next";
import { TOAST_TYPE } from "../../../../constants/Constants";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";

const SaveUserTemplate = () => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [activeAgentName, setActiveAgentName] = useState("");

  const { showToastv2 } = useContext(toastContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { llmReportTitle, editorRef, activeTabKey, activeTab} =
    useContext(studyReportContext);

  const {
    isAgenticTab,
    agenticReportAgents,
    selectedReportMention,
  } = useContext(AgenticReportingContext);

  const handleIconClick = () => {
    try {
      let activeAgentId = selectedReportMention?.value;
      const agentName = selectedReportMention?.label;

      if (!activeAgentId && agentName && agenticReportAgents?.length > 0) {
        const matching = agenticReportAgents.find(a => a.label?.toLowerCase() === agentName.toLowerCase());
        if (matching) {
          activeAgentId = matching.value;
        }
      }

      let reportContent = "<div></div>";
      if (editorRef?.current?.editor) {
        reportContent = editorRef.current.editor.html.get();
      }

      if (!activeAgentId) {
        showToastv2(
          TOAST_TYPE.WARNING,
          t("An active agent could not be determined. Please select an agent."),
        );
        return;
      }

      setActiveAgentName(agentName || "the current agent");
      setShowConfirmModal(true);
    } catch (error) {
      console.error("Error saving template:", error);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("An error occurred. Please check the console for details."),
      );
    }
  };

  const executeSave = async () => {
    setShowConfirmModal(false);
    setLoaderRunning(true);
    ref.current.continuousStart();

    let activeAgentId = selectedReportMention?.value;
    const agentName = selectedReportMention?.label;

    if (!activeAgentId && agentName && agenticReportAgents?.length > 0) {
      const matching = agenticReportAgents.find(a => a.label?.toLowerCase() === agentName.toLowerCase());
      if (matching) {
        activeAgentId = matching.value;
      }
    }

    let reportContent = "<div></div>";
    if (editorRef?.current?.editor) {
      reportContent = editorRef.current.editor.html.get();
    }

    const payload = {
      agentId: activeAgentId,
      templateContent: reportContent,
    };

    try {
      const response = await savePersonalTemplate(payload);
      if (
        response &&
        response.status === 200 &&
        response.data?.result !== "FAILURE"
      ) {
        showToastv2(
          TOAST_TYPE.SUCCESS,
          t("Personal template saved successfully!"),
        );
      } else {
        const errorMessage =
          response?.data?.message || t("Failed to save template.");
        showToastv2(TOAST_TYPE.ERROR, `${t("Error")}: ${errorMessage}`);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        t("An unexpected error occurred. Please try again.");
      showToastv2(TOAST_TYPE.ERROR, errorMessage);
      console.error("Caught Exception:", error);
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const cancelSave = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <CustomToolTipHost
        content={t("Save as Personal Template")}
        id="SaveUserTemplate"
        tooltipProps={{
          calloutProps: {
            styles: {
              beak: { background: "#252525;" },
              beakCurtain: { background: "#252525;" },
              calloutMain: { background: "#252525;" },
            },
          },
        }}
      >
        <div
          className="highlight-tool-llm"
          style={{
            cursor: `${isAgenticTab && selectedReportMention && activeTab !== 2 ? "pointer" : "not-allowed"}`,
            marginTop: "2px",
            opacity: isAgenticTab && selectedReportMention && activeTab !== 2 ? 1 : 0.5,
          }}
          onClick={() => {
            if (isAgenticTab && selectedReportMention && activeTab !== 2) handleIconClick();
          }}
        >
          <SaveUserTemplateIcon />
        </div>
      </CustomToolTipHost>
      {showConfirmModal && (
        <ConfirmModal
          handleConfirm={executeSave}
          handleNotConfirm={cancelSave}
          showConfirmModal={showConfirmModal}
          message={t("string-literals.save-default-radiologist-template", {
            agentName: activeAgentName,
          })}
          title={t("confirm-message.confirm-save-template")}
          confirmButtonText={t("Yes")}
        />
      )}
    </>
  );
};

export default SaveUserTemplate;
